<template>
    <div class="custom-container" >
<!--        <iframe :src="src()" title="Iframe Example" class="custom-iframe"></iframe>-->
        <iframe src="https://10.1.134.35:8000/" title="Iframe Example" class="custom-iframe"></iframe>
    </div>
</template>

<script>

    export default {
        name: "Chinese",
        props:{
        },
        data(){
            return{
                token : '1234567890'
            }
        },
        methods:{
            src(){
                return `http://10.5.165.186:8080/`+this.token
            }
        },
        computed:{
        },
        watch:{
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
    }
</script>

<style scoped>
    .custom-container {
        width: 100%;
        min-height: 80vh;
        padding-top: 50px;
    }
    .custom-iframe {
        width: 100%;
        height: 100vh;
        overflow: hidden !important;
    }
</style>